import { Link } from '@tanstack/react-router'
import { Box, Typography } from '@mui/material'

export default function NotFound() {
  return (
    <Box sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Page not found
      </Typography>
      <Typography sx={{ mb: 3 }}>
        The page you are looking for does not exist or has been moved.
      </Typography>
      <Link to="/">Return to homepage</Link>
    </Box>
  )
}
